import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { FormFieldComponent } from '../form-field.component.js';
import { VideoService } from 'lib/ui/video/index.js';

@Component({
    selector: 'ui-video-form-field',
    templateUrl: './video-form-field.component.html',
    styleUrls: ['../form-fields.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VideoFormFieldComponent extends FormFieldComponent<string> {
	public readonly maxLength = input<number>();

	constructor(private videoService: VideoService) {
		super();
	}

	handleModelChange(value?: string): void {
		super.updateValue(value);
	}

	protected getHint(value?: string | null): string | undefined {
		const maxLength = this.maxLength();
		if (maxLength && value && value?.length > maxLength) {
			return `Max length is ${maxLength}`;
		}

		return `Supported sources: ${this.videoService.supportedVideoSources.join(', ')}`;
	}

	protected isValueValid(value?: string | null): boolean {
		const maxLength = this.maxLength();
		if (maxLength) {
			if (!value) {
				return false;
			}
			if (value.length > maxLength) {
				return false;
			}
		}

		if (value) {
			return this.isSupportedEmbedVideo(value);
		}

		return true;
	}

	private isSupportedEmbedVideo(value: string): boolean {
		return this.videoService.embed(value) ? true : false;
	}
}
